// extracted by mini-css-extract-plugin
export var chip = "_bh-0";
export var filterDropdown = "_bh-5";
export var filterItem = "_bh-6";
export var icon = "_bh-1";
export var removeButton = "_bh-3";
export var removeIcon = "_bh-4";
export var separator = "_bh-2";